import { render } from "./modal.vue?vue&type=template&id=3fd6e3a3&scoped=true"
import script from "./modal.vue?vue&type=script&lang=js"
export * from "./modal.vue?vue&type=script&lang=js"

import "./modal.vue?vue&type=style&index=0&id=3fd6e3a3&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3fd6e3a3"

export default script